/**
 * Completes the redirect started by `public/404.html`.
 *
 * On a static host, opening `/projects/handular` directly serves 404.html, which
 * records the path and bounces to the app root. This runs before the router
 * mounts and rewrites the address bar back to the requested path, so the router
 * boots straight into the right route and the visitor never sees the detour.
 */
export function restoreDeepLink(): void {
  let target: string | null = null
  try {
    target = sessionStorage.getItem('spa:redirect')
    if (target) sessionStorage.removeItem('spa:redirect')
  } catch {
    // Storage can be unavailable (private mode, blocked cookies). Nothing to do.
    return
  }

  if (!target || target === location.pathname + location.search + location.hash) return

  // Only ever restore a same-origin path, never an absolute URL.
  if (!target.startsWith('/') || target.startsWith('//')) return

  history.replaceState(null, '', target)
}
